var PageEnum;
(function (PageEnum) {
    PageEnum["booking"] = "booking";
    PageEnum["mypage"] = "mypage";
    PageEnum["findus"] = "findus";
    PageEnum["aboutus"] = "aboutus";
    PageEnum["tos"] = "tos";
    PageEnum["rules"] = "rules";
    PageEnum["blog"] = "blog";
    PageEnum["admin"] = "admin";
    PageEnum["events"] = "events";
})(PageEnum || (PageEnum = {}));
var PageType;
(function (PageType) {
    PageType["base64"] = "base64";
    PageType["builtin"] = "builtin";
    PageType["blog"] = "blog";
})(PageType || (PageType = {}));
const defaultPageSetup = () => {
    return {
        [PageEnum.booking]: {
            id: PageEnum.booking,
            type: PageType.builtin,
            enabled: true,
            path: '/',
            navbar: true,
            navbarOrder: 1,
            navbarTitle: 'Booking'
        },
        [PageEnum.aboutus]: {
            id: PageEnum.aboutus,
            type: PageType.base64,
            enabled: false,
            path: '/omoss',
            navbar: true,
            navbarOrder: 3,
            navbarTitle: 'Om Oss'
        },
        [PageEnum.findus]: {
            id: PageEnum.findus,
            type: PageType.base64,
            enabled: false,
            path: '/herervi',
            navbar: true,
            navbarOrder: 4,
            navbarTitle: 'Her er vi'
        },
        [PageEnum.rules]: {
            id: PageEnum.rules,
            type: PageType.base64,
            enabled: false,
            path: '/regler',
            navbar: true,
            navbarOrder: 5,
            navbarTitle: 'Regler'
        },
        [PageEnum.tos]: {
            id: PageEnum.tos,
            type: PageType.builtin,
            enabled: true,
            path: '/betingelser',
            navbar: true,
            navbarOrder: 6,
            navbarTitle: 'Betingelser'
        },
        [PageEnum.blog]: {
            id: PageEnum.blog,
            type: PageType.blog,
            enabled: false,
            path: '/blog',
            navbar: true,
            navbarOrder: 7,
            navbarTitle: 'Innlegg'
        },
        [PageEnum.mypage]: {
            id: PageEnum.mypage,
            type: PageType.builtin,
            enabled: true,
            path: '/minside',
            navbar: true,
            navbarOrder: 8,
            navbarTitle: 'Min Side'
        },
        [PageEnum.admin]: {
            id: PageEnum.admin,
            type: PageType.builtin,
            enabled: true,
            path: '/admin',
            navbar: true,
            navbarOrder: 9,
            navbarTitle: 'Admin'
        },
        [PageEnum.events]: {
            id: PageEnum.events,
            type: PageType.builtin,
            enabled: true,
            path: '/events',
            navbar: true,
            navbarOrder: 2,
            navbarTitle: 'Arrangementer'
        }
    };
};
const toPageType = (raw) => {
    switch (raw) {
        case 'base64':
            return PageType.base64;
        case 'builtin':
            return PageType.builtin;
        case 'blog':
            return PageType.blog;
        default:
            return PageType.builtin;
    }
};
const toPage = (id, raw) => {
    return {
        id,
        type: toPageType(raw.type),
        enabled: !!raw.enabled,
        path: raw.path || '/',
        navbar: !!raw.navbar,
        navbarOrder: raw.navbarOrder || 0,
        navbarTitle: raw.navbarTitle || ''
    };
};
const toPages = (raw) => {
    const result = defaultPageSetup();
    if (!raw)
        return result;
    for (const id of Object.values(PageEnum)) {
        if (raw[id])
            result[id] = toPage(id, raw[id]);
    }
    // Fix wrong data from older site versions
    const orderArray = Object.values(result).map((page) => page.navbarOrder);
    const orderDuplicates = orderArray.filter((order, index) => orderArray.indexOf(order) !== index);
    if (orderDuplicates.length > 0) {
        // Let's just use decimal
        let addition = 0.1;
        for (const page of Object.values(result)) {
            if (orderDuplicates.includes(page.navbarOrder)) {
                page.navbarOrder += addition;
                addition += 0.1;
            }
        }
    }
    return result;
};
// Assuming that the pathname is either a page or a subpage of a known page - find which one
const pageFromUrl = (siteCxt, url, pages) => {
    const rootPage = Object.values(pages).find((page) => page.path === '/') ||
        pages[PageEnum.booking];
    const pathWithoutPrefix = url.pathname.startsWith(siteCxt.sitePrefix)
        ? url.pathname.substring(siteCxt.sitePrefix.length)
        : url.pathname;
    const parts = pathWithoutPrefix.split('/').filter((part) => part !== '');
    if (parts.length === 0) {
        return rootPage;
    }
    const page = Object.values(pages).find((page) => page.path === '/' + parts[0]);
    if (page) {
        return page;
    }
    return rootPage;
};
export { toPages, defaultPageSetup, PageEnum, PageType, pageFromUrl };
//# sourceMappingURL=page.js.map